import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import '../styles/SinteredCollection.css';
import { productdata } from './data';
import stwra from '../images/statuario.webp' 
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

const Products = () => {
  const [data] = useState(productdata)

  const navigate = useNavigate();

  return (
    <div>
      <div className="collection">
      <div className="text-section1">
        <h3>Marble and Stone, Redefined.</h3>
        <h1>Timeless Elegance Collection
        </h1>
        <p>
        Crafted with precision, our marbles and stones are built to last, offering unmatched durability even in the most demanding environments. Combining timeless elegance with superior strength, they are designed to stand the test of time while maintaining their flawless beauty. Whether for residential or commercial projects, our versatile range seamlessly adapts to any design style, providing the perfect blend of aesthetics and functionality.
        </p>
      </div>

      <div className="image-section">
        <img src={stwra} alt="Statuario marble kitchen" />
      </div>
    </div>
    <div className="product-container">
        
    
      <div className="product-grid">
        {data.map((product) => (
          <Card className='product-card'>
          <Card.Img variant="top" className='card-image' src={product.image} />
          <Card.Body>
            <Card.Title>{product.name}</Card.Title>
            <Card.Text>
              {product.about}
            </Card.Text>
            <Button variant="warning" onClick={() => navigate(`/details/${product.id}`)}> veiw details</Button>
          </Card.Body>
        </Card>
        ))}
      </div>
      
    </div></div>
  );
};

export default Products;
